import React from 'react';
import { Tabs } from 'antd';
import { useLocation, useNavigate } from 'react-router-dom';
import { RulesPage } from './RulesPage';
import { DecisionLogsPage } from './DecisionLogsPage';

export const GeoBlockPage: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  return <Tabs activeKey={location.pathname.endsWith('/decision-logs') ? 'decision-logs' : 'rules'}
    onChange={(tab) => navigate(`/geo-access/${tab}`)} items={[
      { key: 'rules', label: 'Config Rule', children: <RulesPage /> },
      { key: 'decision-logs', label: 'Decision Logs', children: <DecisionLogsPage /> },
    ]} />;
};
